import React, {useEffect, useState} from "react";
import {ToggleSwitch} from "@arctheme-components/elements/ToggleSwitch/ToggleSwitch";
import {useAlpineStore} from "@arctheme-hooks/useAlpineStore";

export const CollectionToolbar = ({ settings, toggleSidebar, filterButtonSettings, sortDropdownSettings }) => {

    const [selectedOption, setSelectedOption] = useState("Popular");

    // Default labels
    const defaultFilterLabel = "Filters";
    const defaultSortLabel = "Sort By:";

    // Use settings labels if available, otherwise use defaults
    const filterLabel = filterButtonSettings?.filter_button_label || defaultFilterLabel;
    const sortLabel = sortDropdownSettings?.sort_label || defaultSortLabel;

    // Construct class names based on settings
    const filterButtonClasses = `${filterButtonSettings?.font_class || `b4--bold`} ${filterButtonSettings?.filter_button_font_class_mobile || ''} lg:${filterButtonSettings?.filter_button_font_class_desktop || ''}`;
    const sortLabelClasses = `${sortDropdownSettings?.font_class || `b4--bold`} whitespace-nowrap ${sortDropdownSettings?.sort_label_font_class_mobile || ''} lg:${sortDropdownSettings?.sort_label_font_class_desktop || ''}`;
    const sortSelectClasses = `pl-2 pb-0 border-0 b4 text-[#636b6f] ${sortDropdownSettings?.sort_options_font_class_mobile || ''} lg:${sortDropdownSettings?.sort_options_font_class_desktop || ''}`;

    const handleSelectChange = (event) => {
        const newValue = event.target.value;
        setSelectedOption(newValue);

        // Emit the event to sort products based on the selected sort option
        const sortEvent = new CustomEvent('searchrequest-sortchanged', {
            detail: {
                sortOption: newValue
            }
        });
        window.dispatchEvent(sortEvent);
    };

    return (
        <div className="flex items-center space-x-4 border-b border-t lg:border-0 justify-end w-full">
            <div className={'flex toolbar-items pl-4 pr-1 lg:py-2 py-3 justify-between lg:justify-normal lg:gap-10 border-0 lg:border w-full lg:w-auto'}>
                {/* Filters Button */}
                <button className={filterButtonClasses} onClick={toggleSidebar}>
                    <i className={'icon icon-filter-simple'}></i>
                    {filterLabel}
                </button>

                {/* Sort By Dropdown */}
                <div className="relative flex items-center justify-center">
                    <span className={sortLabelClasses}>{sortLabel}</span>
                    <select
                        value={selectedOption}
                        onChange={handleSelectChange}
                        className={sortSelectClasses}
                    >
                        <option value="Popular">Popular</option>
                        <option value="Newest">Newest</option>
                        <option value="LowToHigh">Price - Low to High</option>
                        <option value="HighToLow">Price - High to Low</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

